
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-price/[series]",
      function () {
        return require("private-next-pages/build-price/[series]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build-price/[series]"])
      });
    }
  